import { ComponentProps } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import GenericPlusUpsell from '@alltrails/upsell/components/UpsellSystem/GenericPlusUpsell/GenericPlusUpsell';
import connectGarminCoros from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/connectGarminCoros';
import trailConditions from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/trailConditions';
import unlimitedMapDownloads from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/unlimitedMapDownloads';
import headerImageSrc from './3d-maps-web.avif';

type Props = {
  isOpen: ComponentProps<typeof GenericPlusUpsell>['isOpen'];
  onCloseRequest: ComponentProps<typeof GenericPlusUpsell>['onCloseRequest'];
};

// https://www.figma.com/design/PtYSSpohQ9rL7ZWCcdsYJK/2025-Upsell-System?node-id=1869-64624&m=dev
export default function ThreeDMapsUpsellModal({ isOpen, onCloseRequest }: Props) {
  const intl = useIntl();

  return (
    <GenericPlusUpsell
      headerImageSrc={headerImageSrc}
      heading={<FormattedMessage defaultMessage="View trail elevation and terrain in 3D" />}
      isOpen={isOpen}
      onCloseRequest={onCloseRequest}
      promoEligibleHeading={<FormattedMessage defaultMessage="Try 3D Maps and more for free" />}
      subscriptionFeatures={[unlimitedMapDownloads(intl), trailConditions(intl), connectGarminCoros(intl)]}
      upsellTrigger="three d maps tapped"
    />
  );
}
